module.exports = __webpack_public_path__ + "img/email-black.e2d0b4aa.svg";